import { Helmet } from "react-helmet"
import { useState } from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

function Secondtheme({ get_data }) {
    const imgBase = "https://admin.reliep.com/services/";
    let imgsArr = [];
    const other = get_data?.other_images;
    if (Array.isArray(other)) { imgsArr = other } else if (typeof other === 'string') { try { imgsArr = JSON.parse(other) } catch(e) { imgsArr = [] } }
    const gallery = imgsArr.map(n => (n && n.startsWith('http')) ? n : (n ? imgBase + n : null)).filter(Boolean);
    const mosaicImgs = gallery.length ? gallery : [
        "https://images.unsplash.com/photo-1515165562835-c3b8c3c9a7fa?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1473186578172-c141e6798cf4?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1490474418585-ba9bad8fd0ea?q=80&w=800&auto=format&fit=crop",
        "https://images.unsplash.com/photo-1469474968028-56623f02e42e?q=80&w=800&auto=format&fit=crop"
    ];
    const ps = Array.isArray(get_data?.product_services) ? get_data.product_services : [];
    const cats = Array.isArray(get_data?.all_categories) ? get_data.all_categories : [];
    const clean = (s) => (typeof s === 'string' ? s.replace(/[`\s]/g, '').replace(/^"|"$/g, '') : s);
    const cardImage = (item) => {
        const f = clean(item?.featured_image);
        if (f) return f;
        const oi = item?.other_images;
        let arr = [];
        if (Array.isArray(oi)) arr = oi; else if (typeof oi === 'string') { try { arr = JSON.parse(oi) } catch(e) { arr = [] } }
        return arr[0] || null;
    };
    const phone = get_data?.mobile || get_data?.contact_no || get_data?.phone || null;
    const reviews = Array.isArray(get_data?.review_ratings) ? get_data.review_ratings : [];
    const stars = (n) => {
        const s = Math.max(0, Math.min(5, parseInt(n)));
        return '★★★★★'.slice(0, s).padEnd(5, '☆');
    };
    const initials = (name) => {
        if (!name || typeof name !== 'string') return 'US';
        const compact = name.replace(/\s+/g, '');
        return compact.slice(0,2).toUpperCase() || 'US';
    };
    const [showAllCats, setShowAllCats] = useState(false);
    const avg = parseFloat(get_data?.ratings_average || 0);
    const count = parseInt(get_data?.rating_count || reviews.length || 0);
    return (
        <>
            <Helmet>
                <title>{(get_data?.service_name || get_data?.first_name || "Partner Store") + " - Partner Store"}</title>
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&family=Playfair+Display:ital,wght@1,600&display=swap" rel="stylesheet" />
            </Helmet>
            <style>{`
*{box-sizing:border-box;margin:0;padding:0}
body{font-family:Poppins,system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;background:#f5f7fb;color:#0f1b2a;line-height:1.5}
:root{--text:#0f1b2a;--muted:#64748b;--accent:#e43c3c;--primary:#5b5cf7;--card:#ffffff;--shadow:0 20px 40px rgba(15,27,42,.08)}
.container{max-width:1140px;margin:0 auto;padding:0 24px}
header{position:relative;background:radial-gradient(1100px 450px at 80% 10%, #e6ecff 0%, transparent 60%),linear-gradient(180deg,#eef3ff 0%,#f5f7fb 100%)}
.nav{display:flex;align-items:center;justify-content:space-between;padding:20px 0}
.brand{display:flex;align-items:center;gap:10px;font-weight:700}
.brand-mark{width:26px;height:18px;border-radius:999px;background:conic-gradient(from 180deg,#ff6b6b,#ff3b3b,#e60026);transform:skewX(-15deg)}
.nav ul{list-style:none;display:flex;gap:28px;color:var(--muted)}
.nav a{text-decoration:none;color:inherit}
.cta{display:inline-flex;align-items:center;gap:8px;background:var(--primary);color:#fff;border:none;border-radius:999px;padding:12px 20px;font-weight:600;box-shadow:0 10px 24px rgba(91,92,247,.35)}
.hero{display:grid;grid-template-columns:1.2fr 1fr;gap:40px;align-items:center;padding:40px 0 80px}
.hero h1{font-size:44px;font-weight:700;letter-spacing:.2px}
.accent{font-family:"Playfair Display",serif;font-style:italic;color:var(--accent)}
.hero p{color:var(--muted);margin-top:16px}
.hero .actions{margin-top:28px;display:flex;gap:14px}
.secondary{background:#fff;color:var(--text);border:1px solid #e5e7eb}
.hero-visual{position:relative}
.blob{position:relative;width:420px;height:420px;margin-left:auto;border-radius:46% 54% 55% 45%/56% 43% 57% 44%;background:linear-gradient(135deg,#dfe6ff 0%,#f5f7fb 60%);box-shadow:var(--shadow);display:grid;place-items:center}
.blob img{width:82%;height:82%;object-fit:cover;border-radius:50%;box-shadow:0 14px 30px rgba(0,0,0,.12)}
.section{padding:80px 0}
.section h2{font-size:32px}
.lead{color:var(--muted);max-width:760px;margin-top:10px}
.cards{display:grid;grid-template-columns:repeat(4,1fr);gap:22px;margin-top:34px}
.card{background:var(--card);border-radius:16px;padding:22px;box-shadow:var(--shadow)}
.icon{width:38px;height:38px;border-radius:12px;display:grid;place-items:center;color:#fff;font-weight:700}
.icon.green{background:#10b981}.icon.blue{background:#3b82f6}.icon.purple{background:#8b5cf6}.icon.yellow{background:#f59e0b}
.card h3{font-size:18px;margin-top:12px}
.card p{color:var(--muted);margin-top:8px;font-size:14px}
.banner{position:relative;border-radius:18px;overflow:hidden;margin-top:60px}
.banner .grid{display:grid;grid-template-columns:repeat(5,1fr);gap:6px}
.banner .grid img{width:100%;height:160px;object-fit:cover;border-radius:8px}
.banner .overlay{position:absolute;inset:0;background:linear-gradient(180deg,rgba(10,18,31,.65),rgba(10,18,31,.35) 40%,rgba(10,18,31,.75));display:grid;place-items:center;text-align:center}
.banner .overlay h3{color:#fff;font-size:26px;max-width:760px}
.portfolio{margin-top:60px}
.grid-3{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-top:20px}
.grid-3 img{width:100%;height:220px;object-fit:cover;border-radius:12px;box-shadow:var(--shadow)}
.methods{display:grid;grid-template-columns:1fr 1fr;gap:40px;align-items:center}
.illustration{width:100%;height:360px;border-radius:24px;background:radial-gradient(180px 180px at 25% 60%,#c7d2fe,transparent 60%),radial-gradient(120px 120px at 70% 20%,#93c5fd,transparent 60%),#eef2ff;display:grid;place-items:center}
.illustration svg{width:56%;height:auto}
.panel{background:#fff;border:1px solid #edf1f7;border-radius:16px;padding:24px;box-shadow:var(--shadow)}
.panel h3{font-size:22px}
.panel p{color:var(--muted);margin-top:10px}
.checks{display:grid;grid-template-columns:1fr;gap:10px;margin-top:16px}
.check{display:flex;align-items:flex-start;gap:10px}
.check i{width:22px;height:22px;border-radius:50%;background:#22c55e;color:#fff;font-size:14px;display:grid;place-items:center}
.table{margin-top:18px;display:grid;grid-template-columns:repeat(3,1fr);gap:10px}
.cell{background:#f8fafc;border-radius:12px;padding:12px;text-align:center}
.stats{display:grid;grid-template-columns:repeat(4,1fr);gap:18px;margin-top:28px}
.stat{background:#fff;border-radius:14px;padding:18px;text-align:center;box-shadow:var(--shadow)}
.stat b{font-size:22px}
.cat-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:18px;margin-top:16px}
.cat-card{background:#fff;border-radius:14px;padding:16px;box-shadow:var(--shadow);border:1px solid #e5e7eb;text-align:center}
.cat-icon{width:100%;height:240px;border-radius:14px;background:#eef2ff;display:grid;place-items:center;color:#0f1b2a;font-weight:700;font-size:42px;overflow:hidden;margin:0 auto 12px}
.cat-icon img{width:100%;height:100%;object-fit:cover;border-radius:14px}
.cat-name{margin-top:8px;font-weight:700}
.cat-desc{color:var(--muted);margin-top:6px}
.cat-actions{display:flex;justify-content:center;margin-top:14px}
.testimonials{margin-top:40px}
.t-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:20px;margin-top:24px}
.t-card{background:#fff;border-radius:16px;padding:22px;box-shadow:var(--shadow)}
.t-head{display:flex;align-items:center;gap:12px}
.avatar{width:44px;height:44px;border-radius:50%;object-fit:cover}
.t-name{font-weight:600}
.t-role{color:var(--muted);font-size:13px}
.stars{margin-top:8px;color:#f59e0b}
.contact{display:grid;grid-template-columns:1.2fr .8fr;gap:34px;align-items:center;margin-top:40px}
.contact .photo{width:100%;height:360px;border-radius:18px;object-fit:cover;box-shadow:var(--shadow)}
.form{background:#fff;border-radius:16px;padding:22px;box-shadow:var(--shadow)}
.form .row{display:grid;grid-template-columns:1fr 1fr;gap:12px}
.form label{display:block;font-size:13px;color:var(--muted);margin-bottom:6px}
.form input,.form textarea{width:100%;border:1px solid #e5e7eb;border-radius:10px;padding:12px;font:inherit}
.form textarea{min-height:120px;resize:vertical}
.form .actions{margin-top:12px;display:flex;gap:12px}
footer{margin-top:60px;background:#fff}
.footer-top{display:grid;grid-template-columns:1fr 1fr 1fr;gap:20px;padding:24px 0;border-top:1px solid #e5e7eb}
.newsletter{display:flex;gap:10px}
.newsletter input{flex:1;border:1px solid #e5e7eb;border-radius:999px;padding:10px 14px}
.footer-bottom{display:flex;justify-content:space-between;align-items:center;padding:16px 0;border-top:1px solid #eef2f7;color:var(--muted)}
.dots{display:flex;gap:6px}
.dot{width:6px;height:6px;border-radius:50%;background:#cbd5e1}
@media (max-width:992px){.hero{grid-template-columns:1fr}.cards{grid-template-columns:1fr 1fr}.methods{grid-template-columns:1fr}.t-grid{grid-template-columns:1fr 1fr}.contact{grid-template-columns:1fr}.grid-3{grid-template-columns:1fr 1fr}}
@media (max-width:640px){.cards{grid-template-columns:1fr}.t-grid{grid-template-columns:1fr}.grid-3{grid-template-columns:1fr}}

.s-card{background:#fff;border:1px solid #edf2f7;border-radius:18px;box-shadow:var(--shadow);padding:16px;transition:transform .2s ease, box-shadow .2s ease}
.s-card:hover{transform:translateY(-4px);box-shadow:0 30px 50px rgba(15,27,42,.12)}
.s-thumb{position:relative;height:180px;border-radius:14px;overflow:hidden;margin-top:8px}
.s-thumb img{width:100%;height:100%;object-fit:cover}
.s-badge{position:absolute;left:12px;top:12px;background:linear-gradient(135deg,#5b5cf7,#7d7df9);color:#fff;border-radius:999px;padding:6px 10px;font-weight:700;box-shadow:0 10px 20px rgba(91,92,247,.25)}
.s-icon{width:42px;height:42px;border-radius:12px;background:linear-gradient(135deg,#5b5cf7,#7d7df9);color:#fff;display:grid;place-items:center;font-weight:700}
.s-title{margin-top:8px;font-weight:700}
.s-desc{color:var(--muted);margin-top:6px}
.s-actions{display:flex;gap:10px;margin-top:10px}
.owl-theme .owl-nav [class*='owl-']{background:#fff;border:1px solid #e5e7eb;color:#5b5cf7;border-radius:999px;padding:6px 12px;box-shadow:var(--shadow)}
.owl-theme .owl-nav [class*='owl-']:hover{background:#5b5cf7;color:#fff}
.rating-summary{display:flex;align-items:center;justify-content:space-between;background:linear-gradient(135deg,#f9fafe 0%,#eef3ff 100%);border-radius:18px;padding:16px 18px;box-shadow:var(--shadow);margin-bottom:18px}
.rs-value{display:flex;align-items:center;gap:10px}
.rs-score{font-size:28px;font-weight:800;color:#0f1b2a}
.rs-stars{color:#f59e0b}
.rs-count{color:#64748b}
.rs-cta{display:flex;gap:10px}
.rs-cta .cta{padding:10px 14px;border-radius:10px}
            `}</style>

            <header>
                <div className="container">
                    <div className="nav">
                        <div className="brand"><img src="https://reliep.com/services-img/images/logo.png" style={{width: "100px"}}></img></div>
                        <ul>
                            <li><a href="#">Home</a></li>
                            <li><a href="#services">Services</a></li>
                            <li><a href="#portfolio">Portfolio</a></li>
                            <li><a href="#testimonials">Testimonials</a></li>
                            <li><a href="#contact">Contact</a></li>
                        </ul>
                        <button className="cta">Get Started</button>
                    </div>
                    <div className="hero container">
                        <div>
                            <h1>Professional <span className="accent">{get_data?.service_name || get_data?.service?.service_name || "Quality"}</span> Services For Every Need.</h1>
                            <p>Trusted experts delivering reliable service, transparent pricing, and customer-first support from consultation to completion.</p>
                            <div className="actions">
                                <button className="cta">Consult Now</button>
                                <button className="cta secondary">Learn More</button>
                            </div>
                        </div>
                        <div className="hero-visual">
                            <div className="blob">
                                <img
                                    alt="Hero"
                                    src={get_data?.featured_image || "https://images.unsplash.com/photo-1517242026073-6a3c6b3f0b60?q=80&w=900&auto=format&fit=crop"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <main>
                <section className="section" id="services">
                    <div className="container">
                        <h2>Available Services</h2>
                        <p className="lead">Browse offerings with transparent pricing and quality delivery.</p>
                        {ps.length ? (
                            <OwlCarousel
                                className="owl-theme"
                                nav
                                navText={["‹","›"]}
                                loop={ps.length > 3}
                                margin={18}
                                autoplay
                                dots
                                responsive={{
                                    0: { items: 1 },
                                    640: { items: 2 },
                                    992: { items: 3 }
                                }}
                            >
                                {ps.map((item, idx) => (
                                    <div key={idx} className="s-card">
                                        <div className="s-icon">{(item?.service_name || 'SV').slice(0,2).toUpperCase()}</div>
                                        <div className="s-title">{item?.service_name}</div>
                                        <div className="s-desc">{item?.description || 'Professional service with care and reliability.'}</div>
                                        {cardImage(item) ? (
                                            <div className="s-thumb">
                                                {item?.price ? (<div className="s-badge">₹{item.price}</div>) : null}
                                                <img src={cardImage(item)} alt={item?.service_name || 'service'} />
                                            </div>
                                        ) : null}
                                        <div className="s-actions">
                                            <a className="cta" href={phone ? `tel:${phone}` : '/contact-us'}>Call Now</a>
                                            <a className="cta secondary" href="/contact-us">Enquire Now</a>
                                        </div>
                                    </div>
                                ))}
                            </OwlCarousel>
                        ) : (
                            <div className="lead">No services listed yet.</div>
                        )}
                    </div>
                </section>

                <section className="section portfolio" id="portfolio">
                    <div className="container">
                        <h2>Meet our portfolio to <span className="accent">kickstart</span> your success.</h2>
                        <div>
                            <OwlCarousel
                                className="owl-theme"
                                nav
                                navText={["‹","›"]}
                                loop={mosaicImgs.length > 3}
                                margin={12}
                                dots
                                autoplay
                                autoplayTimeout={2500}
                                autoplayHoverPause
                                slideBy={1}
                                responsive={{
                                    0: { items: 1 },
                                    640: { items: 2 },
                                    992: { items: 3 }
                                }}
                            >
                                {mosaicImgs.map((src, idx) => (
                                    <div key={idx} className="p-item">
                                        <img
                                            src={src}
                                            alt={`portfolio-${idx+1}`}
                                            style={{ width: '100%', height: '220px', objectFit: 'cover', borderRadius: '12px', boxShadow: 'var(--shadow)' }}
                                        />
                                    </div>
                                ))}
                            </OwlCarousel>
                        </div>
                    </div>
                </section>

                <section className="section" id="categories">
                    <div className="container">
                        <h2>Categories</h2>
                        <p className="lead">Browse available service categories.</p>
                        <div className="cat-grid">
                            {(showAllCats ? cats : cats.slice(0,9)).map((c, idx) => (
                                <div key={idx} className="cat-card">
                                    <div className="cat-icon">
                                        {clean(c?.icon) ? (
                                            <img src={clean(c.icon)} alt={c?.name || 'category'} />
                                        ) : (
                                            (c?.name || 'CT').slice(0,2).toUpperCase()
                                        )}
                                    </div>
                                    <div className="cat-name">{c?.name}</div>
                                    <div className="cat-desc">{c?.description || 'Category'}</div>
                                </div>
                            ))}
                        </div>
                        {cats.length > 9 ? (
                            <div className="cat-actions">
                                {!showAllCats ? (
                                    <button className="cta" onClick={() => setShowAllCats(true)}>See All</button>
                                ) : (
                                    <button className="cta secondary" onClick={() => setShowAllCats(false)}>Show Less</button>
                                )}
                            </div>
                        ) : null}
                    </div>
                </section>

                <section className="section" id="methods">
                    <div className="container methods">
                        <div className="illustration">
                            <img
                                alt={get_data?.service_name || get_data?.service?.service_name || "gallery"}
                                src={mosaicImgs[0] || (get_data?.featured_image || "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1200&auto=format&fit=crop")}
                                style={{ width: '90%', height: 'auto', borderRadius: '18px', boxShadow: 'var(--shadow)' }}
                            />
                        </div>
                        <div className="panel">
                            <h3>Our <span className="accent">{get_data?.service_name || get_data?.service?.service_name || "quality"}</span> approach fits your needs.</h3>
                            <p>{get_data?.description || "We combine research‑driven design and quality engineering to deliver reliable products that scale with your business."}</p>
                            <div className="checks">
                                {ps.length ? (
                                    ps.slice(0,4).map((item, idx) => (
                                        <div key={idx} className="check"><i>✓</i><div>{item?.service_name || 'Service'}</div></div>
                                    ))
                                ) : (
                                    <>
                                        <div className="check"><i>✓</i><div>Discovery workshops and product roadmapping</div></div>
                                        <div className="check"><i>✓</i><div>Design systems and accessible UI patterns</div></div>
                                        <div className="check"><i>✓</i><div>Robust CI/CD with automated testing</div></div>
                                        <div className="check"><i>✓</i><div>Performance and SEO best practices</div></div>
                                    </>
                                )}
                            </div>
                            <div className="table">
                                {(get_data?.payment_mode || 'Online, Offline').split(',').map(m => m.trim()).slice(0,3).map((m, idx) => (
                                    <div key={idx} className="cell">{m}</div>
                                ))}
                            </div>
                            <div className="stats">
                                <div className="stat"><b>{isNaN(avg) ? '-' : avg}</b><div>Avg Rating</div></div>
                                <div className="stat"><b>{count}</b><div>Reviews</div></div>
                                <div className="stat"><b>{ps.length}</b><div>Services</div></div>
                                <div className="stat"><b>{get_data?.payment_mode || 'Online, Offline'}</b><div>Payment Modes</div></div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="section testimonials" id="testimonials">
                    <div className="container">
                        <h2>Client’s Testimonials</h2>
                        <div className="rating-summary">
                            <div className="rs-value">
                                <div className="rs-score">{isNaN(avg) ? '-' : avg}</div>
                                <div className="rs-stars">{stars(isNaN(avg) ? 0 : Math.round(avg))}</div>
                                <div className="rs-count">{count} reviews</div>
                            </div>
                            <div className="rs-cta">
                                <a className="cta" href={phone ? `tel:${phone}` : '/contact-us'}>Call Now</a>
                                <a className="cta secondary" href="/contact-us">Write a Review</a>
                            </div>
                        </div>
                        <div className="t-grid">
                            {reviews.length ? (
                                reviews.map((r, idx) => (
                                    <div key={idx} className="t-card">
                                        <div className="t-head">
                                            <div className="avatar" style={{width:'44px',height:'44px',borderRadius:'50%',display:'grid',placeItems:'center',background:'#eef2ff',color:'#0f1b2a',fontWeight:700}}>{initials(r.first_name)}</div>
                                            <div>
                                                <div className="t-name">{r.first_name}</div>
                                                <div className="t-role">{(r.date || '').slice(0,10)}</div>
                                            </div>
                                        </div>
                                        <div className="stars">{stars(r.ratings)}</div>
                                        <p style={{ marginTop: "10px", color: "var(--muted)" }}>{r.comments}</p>
                                    </div>
                                ))
                            ) : (
                                <>
                                    <div className="t-card">
                                        <div className="t-head">
                                            <div className="avatar" style={{width:'44px',height:'44px',borderRadius:'50%',display:'grid',placeItems:'center',background:'#eef2ff',color:'#0f1b2a',fontWeight:700}}>AC</div>
                                            <div>
                                                <div className="t-name">Alex Carter</div>
                                                <div className="t-role">Startup Founder</div>
                                            </div>
                                        </div>
                                        <div className="stars">★★★★★</div>
                                        <p style={{ marginTop: "10px", color: "var(--muted)" }}>Exceptional attention to detail and a seamless build process. Our conversion rate jumped within weeks.</p>
                                    </div>
                                    <div className="t-card">
                                        <div className="t-head">
                                            <div className="avatar" style={{width:'44px',height:'44px',borderRadius:'50%',display:'grid',placeItems:'center',background:'#eef2ff',color:'#0f1b2a',fontWeight:700}}>NB</div>
                                            <div>
                                                <div className="t-name">Nicole Blum</div>
                                                <div className="t-role">Product Manager</div>
                                            </div>
                                        </div>
                                        <div className="stars">★★★★★</div>
                                        <p style={{ marginTop: "10px", color: "var(--muted)" }}>Design system rollout was flawless. The team communicated clearly and delivered on schedule.</p>
                                    </div>
                                    <div className="t-card">
                                        <div className="t-head">
                                            <div className="avatar" style={{width:'44px',height:'44px',borderRadius:'50%',display:'grid',placeItems:'center',background:'#eef2ff',color:'#0f1b2a',fontWeight:700}}>DN</div>
                                            <div>
                                                <div className="t-name">Drew Nolan</div>
                                                <div className="t-role">Marketing Lead</div>
                                            </div>
                                        </div>
                                        <div className="stars">★★★★★</div>
                                        <p style={{ marginTop: "10px", color: "var(--muted)" }}>SEO improvements and performance tuning made a measurable impact on traffic.</p>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </section>

                <section className="section" id="contact">
                    <div className="container contact">
                        <img className="photo" src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1400&auto=format&fit=crop" alt="team" />
                        <div className="form">
                            <h3>Get in touch</h3>
                            <p className="lead" style={{ marginTop: "6px" }}>Tell us about your project and goals. We’ll reply within one business day.</p>
                            <div className="row" style={{ marginTop: "14px" }}>
                                <div>
                                    <label>Full Name</label>
                                    <input type="text" placeholder="John Doe" />
                                </div>
                                <div>
                                    <label>Email</label>
                                    <input type="email" placeholder="john@example.com" />
                                </div>
                            </div>
                            <div style={{ marginTop: "12px" }}>
                                <label>Message</label>
                                <textarea placeholder="Write your message"></textarea>
                            </div>
                            <div className="actions">
                                <button className="cta">Send Message</button>
                                <button className="cta secondary">Schedule Call</button>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <footer>
                <div className="container footer-top">
                    <div>
                        <div className="brand"><img src="https://reliep.com/services-img/images/logo.png" style={{width: "100px"}}></img></div>
                        <p style={{ marginTop: "10px", color: "var(--muted)" }}>Design and development studio crafting delightful experiences.</p>
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <div style={{ fontWeight: 600 }}>Links</div>
                        <div style={{ marginTop: "10px", color: "var(--muted)" }}>Home • Services • Portfolio • Testimonials • Contact</div>
                    </div>
                    <div>
                        <div style={{ fontWeight: 600 }}>Newsletter</div>
                        <div className="newsletter" style={{ marginTop: "10px" }}>
                            <input type="email" placeholder="your@email.com" />
                            <button className="cta">Join</button>
                        </div>
                    </div>
                </div>
                <div className="container footer-bottom">
                    <div>© 2025 Reliep Agency</div>
                    <div className="dots"><div className="dot"></div><div className="dot"></div><div className="dot"></div><div className="dot"></div></div>
                    <div>Privacy • Terms</div>
                </div>
            </footer>
        </>
    )
}
export default Secondtheme
